import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse } from "@/lib/types";

export type SearchContext = "matterContactPicker" | "files";
export type SearchRequest = {
  entityType?: "contact" | "matter";
  view: "suggestions" | "list" | "count";
  query?: string;
  context?: SearchContext;
  filters?: object;
  sort?: string;
  order?: "asc" | "desc";
  pageNumber?: number;
  pageSize?: number;
  limit?: number;
  cursor?: string;
};

export const searchV4 = async <T>(
  request: SearchRequest,
  signal?: AbortSignal,
) => {
  const response = await authenticatedFastApiAxiosInstance.post<
    APIResponse<T[]>
  >("search/v4", request, { signal });
  return response.data;
};

export const emptySearchResponse = <T>(
  pageNumber = 1,
  pageSize = 100,
): APIResponse<T[]> => ({
  data: [],
  meta: { userMsg: "" },
  pagination: { count: 0, pageNumber, pageSize },
});
